import { Mountain } from "lucide-react";
import { useTrips } from "@/hooks/queries";
import { TripCard } from "@/components/public/TripCard";
import { EmptyState } from "@/components/common";

const Skeletons = () => (
  <div className="grid gap-6 md:grid-cols-2 md:gap-8">
    {[0, 1].map((i) => <div key={i} className="aspect-[4/5] animate-pulse rounded-2xl bg-white/5" />)}
  </div>
);

export const TripsSection = () => {
  const { data: trips, isLoading } = useTrips();
  return (
    <section id="trip" className="relative scroll-mt-16 py-24 md:py-36" data-testid="home-trips-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 grid gap-8 md:mb-20 md:grid-cols-12">
          <div className="md:col-span-7">
            <p className="overline-label">Destinasi</p>
            <h2 className="mt-4 font-display text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">
              Pilih gunungmu, <em className="text-gold">tentukan tanggalmu.</em>
            </h2>
          </div>
          <p className="text-base leading-relaxed text-neutral-400 md:col-span-5 md:pt-12">
            Setiap trip bersifat private — tidak digabung dengan peserta lain. Harga, durasi, dan fasilitas tertera jelas di setiap trip.
          </p>
        </div>
        {isLoading && <Skeletons />}
        {!isLoading && !trips?.length && (
          <EmptyState icon={Mountain} title="Belum ada trip" text="Trip akan segera tersedia." testId="home-trips-empty" />
        )}
        {!!trips?.length && (
          <div className="grid gap-6 md:grid-cols-2 md:gap-8 md:pb-28 md:[&>*:nth-child(even)]:translate-y-28">
            {trips.map((trip, i) => (
              <div key={trip.id} className="reveal" style={{ animationDelay: `${i * 90}ms` }}>
                <TripCard trip={trip} index={i} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
